export const IMAGES = {
  hero: "https://images.pexels.com/photos/29172648/pexels-photo-29172648.jpeg?auto=compress&cs=tinysrgb&w=1800",
  coastalTunnel: "https://images.unsplash.com/photo-1776841797858-241a2cd0a157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w5UU03fDB8MXxzZWFyY2h8NHx8YW1hbGZpJTIwY29hc3QlMjBpdGFseSUyMHRyYXZlbGVyJTIwZXhwbG9yaW5nJTIwY29hc3RhbCUyMGNsaWZmJTIwdmlld3xlbnwwfHx8fDE3ODk3OTM5NjF8MA&ixlib=rb-4.1.0&q=85",
  kyotoCouple: "https://images.pexels.com/photos/15829774/pexels-photo-15829774.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tuscany: "https://images.pexels.com/photos/31208509/pexels-photo-31208509/free-photo-of-lush-italian-vineyard-in-rolling-hills.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const DESTINATIONS = [
  {
    id: "sardinia",
    name: "Sardinia",
    chipLabel: "Italy",
    country: "Italy",
    coords: "41.2167° N · 9.4000° E",
    season: "May - October",
    pace: "Slow & Immersive",
    image: "/sardinia-cove.webp",
    imagePos: "center 40%",
    blurb: "Impossibly clear water and granite islands made for exploring, from hidden coves to the ancient inland.",
    teaser: [
      "Private boat days in the La Maddalena archipelago",
      "Swim coves only the locals know",
      "Long seafood lunches at the water's edge",
    ],
  },
  {
    id: "paris",
    name: "Paris",
    country: "France",
    coords: "48.8566° N · 2.3522° E",
    season: "April - June · September",
    pace: "Slow & Immersive",
    image: "/paris.webp",
    imagePos: "center 35%",
    blurb: "A timeless city to return to again and again, never a gateway, always the destination.",
    teaser: [
      "Market morning with a chef, lunch to follow",
      "A private hour in the ateliers of the Marais",
      "Seine-side apéro as the lights come on",
    ],
  },
  {
    id: "safari",
    name: "On Safari",
    country: "Kenya & Tanzania",
    coords: "2.3333° S · 34.8333° E",
    season: "June - October",
    pace: "Adventure",
    image: "https://images.unsplash.com/photo-1689479665582-51d0c25215b7?w=1400&q=85&auto=format&fit=crop",
    blurb: "Golden grass, big cats and dawns that reset your sense of scale.",
    teaser: [
      "Balloon over the migration at sunrise",
      "Sundowners in a private conservancy",
      "Fall asleep to the sound of the bush",
    ],
  },
  {
    id: "wellness",
    name: "The Wellness Reset",
    country: "Lake Lucerne, Switzerland",
    coords: "47.0333° N · 8.4333° E",
    season: "Year-round",
    pace: "Pure Relaxation",
    image: "/wellness.webp",
    blurb: "Journeys built around the world's most restorative properties, where coming home feeling new is the whole point.",
    cta: "Inquire about our insider offers",
    properties: [
      { name: "Chenot Palace Weggis", url: "https://chenot.com" },
      { name: "Six Senses", url: "https://www.sixsenses.com" },
      { name: "Canyon Ranch", url: "https://www.canyonranch.com" },
      { name: "Mii amo", url: "https://www.miiamo.com" },
      { name: "Miraval", url: "https://www.miravalresorts.com" },
      { name: "SHA Wellness", url: "https://shawellness.com" },
    ],
    teaser: [
      "A daily rhythm of treatments, movement and deep rest",
      "Menus and rituals designed around your body",
      "Space to do absolutely nothing, beautifully",
    ],
  },
  {
    id: "kyoto",
    name: "Japan",
    country: "Japan",
    coords: "35.0116° N · 135.7681° E",
    season: "March - May · October - November",
    pace: "Culinary Led",
    image: "https://images.pexels.com/photos/34938627/pexels-photo-34938627/free-photo-of-vibrant-autumn-foliage-by-the-lakeside.jpeg?auto=compress&cs=tinysrgb&w=1400",
    blurb: "Ancient ritual and neon wildness, a country that rewards the deeply curious.",
    teaser: [
      "Dinner with a geiko in a 200-year-old ochaya",
      "Sleep in a working monastery on Mount Kōya",
      "Forage mountain vegetables with a sansai guide in Nagano",
    ],
  },
];

export const PACE_OPTIONS = [
  { id: "slow", label: "Slow & Immersive" },
  { id: "culinary", label: "Culinary Led" },
  { id: "adventure", label: "Adventure" },
  { id: "relaxation", label: "Pure Relaxation" },
];

export const BUDGET_OPTIONS = [
  { id: "5-10", label: "$5k - $10k" },
  { id: "10-25", label: "$10k - $25k" },
  { id: "25-plus", label: "$25k+" },
];

export const GROUP_TRIPS = [
  {
    id: "mexico-girls-trip",
    title: "Girls Trip: Mexico City & San Miguel de Allende",
    label: "Coming February 2027",
    location: "Mexico City & San Miguel de Allende",
    dates: "February 2027 · 7 days, 6 nights",
    size: "Max 8 travelers",
    image: "https://images.unsplash.com/photo-1739582767008-faa274e18ac2?w=1400&q=85&auto=format&fit=crop",
    blurb: "Two cities, one unforgettable week with your favorite women, mezcal tastings, market mornings, rooftop dinners and the bougainvillea-draped streets of San Miguel at golden hour.",
    highlights: [
      "Private tasting tour of Casa Dragones' historic tequila house",
      "Roma Norte food and mezcal crawl",
      "Rooftop dinner under the Parroquia lights",
    ],
  },
  {
    id: "sardinia-retreat",
    title: "Sardinia Longevity & Culinary Retreat with Jeremy Rock Smith",
    label: "Blue Zone Living",
    location: "Sardinia, Italy",
    dates: "May 14 - 21, 2027 · 7 days",
    size: "Max 10 travelers",
    soldOut: true,
    image: "/sardinia-retreat.jpg",
    imagePos: "center 22%",
    blurb: "A slow week in one of the world's Blue Zones, cooking with nonnas, walking shepherds' trails, swimming emerald coves, and learning how Sardinians turn lunch into a lifestyle.",
    highlights: [
      "Cooking with Sardinian nonnas in a village kitchen",
      "Daily gentle movement and sea swims",
      "Cannonau tasting with a family winemaker",
    ],
  },
  {
    id: "dolomites-bike",
    title: "Bike the Dolomites: The Legendary Sellaronda Four Passes",
    label: "Ride the Great Passes",
    location: "Dolomites, Italy",
    dates: "September 2027 · 6 days",
    size: "Max 8 riders",
    images: [
      { src: "/dolomites-solo.jpg", pos: "center 55%" },
      { src: "/dolomites-group.jpg", pos: "center 55%" },
      { src: "/dolomites.jpg", pos: "62% 50%" },
    ],
    blurb: "Legendary climbs, rifugio lunches and descents you'll replay for years, fully supported, unhurried, and finished each night with Alto Adige wine and a very long dinner.",
    highlights: [
      "Sella Ronda loop with full support van",
      "Rifugio lunches at 2,000 metres",
      "E-bike option on every climb",
    ],
  },
  {
    id: "morocco-womens-trip",
    title: "A Women's Morocco: Souks, Style & Sisterhood",
    label: "Shopping & Sisterhood",
    location: "Marrakech & the Atlas Mountains",
    dates: "October 2027 · 6 nights",
    size: "Max 10 travelers",
    image: "https://images.pexels.com/photos/31576064/pexels-photo-31576064/free-photo-of-colorful-moroccan-baskets-and-textiles-in-marrakech-market.jpeg?auto=compress&cs=tinysrgb&w=1400",
    blurb: "Six nights designed for women who love to shop, taste and wander: souk mornings with a local stylist, artisan collectives, hammam afternoons and rooftop dinners under the Marrakech sky.",
    highlights: [
      "Private souk shopping with a local stylist guide",
      "Berber weaving collective in the Atlas Mountains",
      "Hammam afternoon and riad rooftop dinners",
    ],
  },
];
